import React from 'react';
import {useTranslation} from 'react-i18next';
import Icon from '../../../../../../components/icon';
import './index.css';

function NewLabelsLoading({labels}) {

	const {t} = useTranslation();

	return (
		<div className="new-labels-loading">
			<Icon animated={'pulse'}
			      name="spinner" className="mr-2"/>{t('loadingLabelText')} ... {Math.ceil(labels.contactsGroups.length / labels.pages.totalRecords * 100)}%
		</div>
	);
}

export default NewLabelsLoading;
